module.exports = __webpack_public_path__ + "media/images/home/ic_note-1355bd68e92e99e2d83b16fb6f685bbd.svg";